export default __webpack_public_path__ + "static/media/sportsbra-medium-right-toobig.09ca799c.jpg";